import React from 'react';
import { LinearGaugeAdditionalArrowsDataType } from '../LinearGauge';

interface Props {
  additionalArrowsData: LinearGaugeAdditionalArrowsDataType[];
  arrowPositionAsPercent: string[];
}

export const AdditionalArrowsLinearGauge: React.FC<Props> = ({ additionalArrowsData, arrowPositionAsPercent }) => {
  return (
    <>
      {additionalArrowsData.map((item, index) => (
        <div
          key={index}
          style={{
            left: `${arrowPositionAsPercent[index]}%`,
            transform: item.bigArrow ? `scale(1.25) translateY(-12%) ` : '',
            transformOrigin: 'top left',
          }}
          className={`absolute aspect-auto min-h-[3.75rem] min-w-[3.75rem] z-10 flex flex-col `}
        >
          <div className="ml-[-0.7rem]">
            <img className=" aspect-square h-[2.2rem] w-[1.5rem]  " src={item.img} alt="" />
          </div>
        </div>
      ))}
    </>
  );
};
